import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0aa1f95c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0aa1f95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1f95c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa1f95c')) {
      api.createRecord('0aa1f95c', component.options)
    } else {
      api.reload('0aa1f95c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0aa1f95c&scoped=true&", function () {
      api.rerender('0aa1f95c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LXIs7RWkkWWf/JS/comp/PopupBox.vue"
export default component.exports